import axios from 'axios'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import Icon from '../icon'

const DownloadApps = () => {
  const { t } = useTranslation('common')
  const [androidLink, setAndroidLink] = useState('')

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    const getAndroid = async () => {
      try {
        const response = await api.post<
          ApiResponse<{
            android: {
              download_link: string
              version: string
            }
          }>
        >(
          '/ajax_datav2.php',
          {
            type: 'get_app_version',
          },
          { signal },
        )
        const { status, info } = response.data

        if (status === 1) {
          setAndroidLink(info.android.download_link)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
      }
    }
    getAndroid()

    return () => {
      controller.abort()
    }
  }, [])

  if (!androidLink) return null

  return (
    <div className="flx-str-ctr gap-5 pt-0 pb-[30px] px-5 xl:gap-[60px] xl:pt-0 xl:pb-10 2xl:px-0">
      <div>
        <p className="text-txt text-lg font-Avenir-Heavy xl:text-[22px] xl:mb-1">
          {t('download-the-app')}
        </p>
        <p className="text-txt text-xs xl:text-sm">{t('select-your-device')}</p>
      </div>
      <div className="flx-ctr">
        <a
          className="p-[5px] hover:opacity-80 xl:px-2 xl:py-[5px]"
          href={'https://apps.apple.com/mx/app/mexplay/id6469581767?l=en-GB'}
          target="blank">
          <Icon
            className="fill-txt w-10 h-10 xl:w-[45px] xl:h-[45px]"
            id={'apple'}
          />
        </a>
        <a
          className="p-[5px] hover:opacity-80 xl:px-2 xl:py-[5px]"
          href={'https://play.google.com/store/apps/details?id=com.mexplay_rn'}
          target="blank">
          <svg
            className="w-10 h-10 xl:w-[45px] xl:h-[45px]"
            xmlns="http://www.w3.org/2000/svg"
            width="800px"
            height="800px"
            viewBox="0 0 32 32"
            fill="none">
            <mask
              id="mask0_87_8320"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="7"
              y="3"
              width="24"
              height="26">
              <path
                d="M30.0484 14.4004C31.3172 15.0986 31.3172 16.9014 30.0484 17.5996L9.75627 28.7659C8.52052 29.4459 7 28.5634 7 27.1663L7 4.83374C7 3.43657 8.52052 2.55415 9.75627 3.23415L30.0484 14.4004Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#mask0_87_8320)">
              <path
                d="M7.63473 28.5466L20.2923 15.8179L7.84319 3.29883C7.34653 3.61721 7 4.1669 7 4.8339V27.1664C7 27.7355 7.25223 28.2191 7.63473 28.5466Z"
                fill="url(#paint0_linear_87_8320)"
              />
              <path
                d="M30.048 14.4003C31.3169 15.0985 31.3169 16.9012 30.048 17.5994L24.9287 20.4165L20.292 15.8175L24.6923 11.4531L30.048 14.4003Z"
                fill="url(#paint1_linear_87_8320)"
              />
              <path
                d="M24.9292 20.4168L20.2924 15.8179L7.63477 28.5466C8.19139 29.0232 9.02389 29.1691 9.75635 28.766L24.9292 20.4168Z"
                fill="url(#paint2_linear_87_8320)"
              />
              <path
                d="M7.84277 3.29865L20.2919 15.8177L24.6922 11.4533L9.75583 3.23415C9.11003 2.87878 8.38646 2.95013 7.84277 3.29865Z"
                fill="url(#paint3_linear_87_8320)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_87_8320"
                x1="15.6769"
                y1="10.874"
                x2="7.07106"
                y2="19.5506"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#00C3FF" />
                <stop offset="1" stop-color="#1BE2FA" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_87_8320"
                x1="20.292"
                y1="15.8176"
                x2="31.7381"
                y2="15.8176"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFCE00" />
                <stop offset="1" stop-color="#FFEA00" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_87_8320"
                x1="7.36932"
                y1="30.1004"
                x2="22.595"
                y2="17.8937"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#DE2453" />
                <stop offset="1" stop-color="#FE3944" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_87_8320"
                x1="8.10725"
                y1="1.90137"
                x2="22.5971"
                y2="13.7365"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#11D574" />
                <stop offset="1" stop-color="#01F176" />
              </linearGradient>
            </defs>
          </svg>
        </a>
        <a
          className="p-[5px] hover:opacity-80 xl:px-2 xl:py-[5px]"
          href={androidLink}
          target="blank">
          <Icon className="w-10 h-10 xl:w-[45px] xl:h-[45px]" id={'android'} />
        </a>
      </div>
    </div>
  )
}

export default DownloadApps
